module.exports = __webpack_public_path__ + "img/IT0001117976504.38c22339.png";